module.exports = __webpack_public_path__ + "assets/img/budapark4-1920.2e7b8a6b.webp";